import { Check, X } from "lucide-react";
import { BlendInfoSchema } from "@/data/schema";


export type BlendInfoFormProps = {
  handleSubmit: (author: string, title: string) => void; 
  handleCancel: () => void; 
};

export function BlendInfoForm(props: BlendInfoFormProps) {

  return (
    <div className="fixed inset-0 bg-transparent flex items-center justify-center z-50 p-4">
      <div className="w-full h-full lg:h-full lg:w-full bg-transparent flex flex-col justify-center items-center gap-8 p-6 lg:p-12">
        <h3 className="text-2xl lg:text-4xl font-extrabold text-tertiary mb-4 text-center">
          Add New Spice
        </h3>

        <form
          className="flex flex-col gap-6 w-full max-w-xl"
          onSubmit={(e) => {
          e.preventDefault();
          const formData = new FormData(e.currentTarget);
          const title = formData.get("spiceName")?.toString().trim();
          const author = formData.get("authorName")?.toString().trim();         

          const result = BlendInfoSchema.safeParse({ author, title });
          if (!result.success) return alert(result.error.issues.map(i => i.message).join('\n'));
          props.handleSubmit(result.data.author, result.data.title);
    
          }}
        >

         <label className="flex flex-col gap-2">
            <input
              name="authorName"
              type="text"
              placeholder="Enter your name..."
              className="w-full p-4 rounded-2xl border border-primary text-tertiary placeholder-tertiary/40 outline-0 focus:border-accent focus:ring-1 focus:ring-accent/20 transition-all duration-300 ease-in-out"
            />
          </label>


          <label className="flex flex-col gap-2">
            <input
              name="spiceName"
              type="text"
              placeholder="Enter spice name..."
              className="w-full p-4 rounded-2xl border border-tertiary/30 text-tertiary placeholder-tertiary/40 outline-0 focus:border-accent focus:ring-1 focus:ring-accent/20 transition-all duration-300 ease-in-out"
            />
          </label>

          <div className="flex justify-center gap-6 mt-6 w-full max-w-xl">
            <button
              type="button"
              className="btn flex items-center gap-2"
              onClick={() => {
                props.handleCancel()                                      // reset
                //setFilter({ isShaken: false });                         // reset
              }}
            >
              <X className="h-5 w-5 text-tertiary" />
              Cancel
            </button>

            <button type="submit" className="btn flex items-center gap-2">
              <Check className="h-5 w-5 text-main" />
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
